// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export const lang = {
  // ...zhLocale,
  // 登录
  'Sign_in_title': '账户登录',
  'Sign_in': '登录',
  'Register': '注册',
  // 注册
  'Register_title': '注册',
  'clickChange': '点击更换',
  'Existing-account': '已有账号',
  'The password should be six digits': '密码应为6位',//密码应为6位
  'Please enter the account': '请输入账号',
  'please input your account name': '请输入帐户名称',
  'Please_enter_account': '请输入账号',
  'Please_input_a_password': '请输入密码',
  'Please input new password': '请输入新密码',
  'Please_input_a_password_again': '请再次输入密码',
  'Please-enter-verification-code': '请输入验证码',
  'Failed to get image captcha': '获取图像验证码失败',
  // 菜单列表
  'Equipment Management': '设备管理',
  'Battery Management': '电池管理',
  'Swapping Station Management': '换电柜管理',
  'Order Management': '订单管理',
  'New Card Order': '开卡订单',
  'Renewal Order': '续费订单',
  'Swapping Order': '换电订单',
  'Agent Management': '代理商管理',
  'Organization Management': '组织管理',
  'User Management': '用户管理',
  'Card Management': '卡管理',
  'Add File': '添加文件',
  'Edit battery ownership': '编辑电池归属',
  'Max battery temperature': '电池最高温度',
  'Min battery temperature': '电池最低温度',
  'Discharge MOS temperature': '放电MOS温度',
  'Charge MOS temperature': '充电MOS温度',
  'Battery power board temperature': '电池功率板温度',
  'Battery status': '电池使用状态',
  // 电池管理
  'Equipment Number': '设备编号',
  'Please enter the device number': '请输入设备编号/通讯板编号/壳体编号/电池二维码',
  'Attribution Type': '归属类型',
  'Attribution Object': '归属对象',
  'Attribution Object Type': '归属对象类型',
  'Lock Cause': '锁定原因',
  'User Phone': '用户手机号',
  'Selection Certificate': '选择凭证',
  'Please enter your mobile phone number': '请输入用户手机号',
  'Please enter the name of the switchboard': '请输入换电柜名称',
  'Attribution Subobject': '归属子对象',
  'Please enter the voucher number': '请输入凭证编号',
  'Communication Board Number': '通讯板编号',
  'Attribution information': '归属信息',
  // 换电柜管理
  'Assign the change cabinet': '分配换电柜',
  'Select time range': '选择时间范围',
  'Please select equipmente': '请选择设备',
  'Equipment number': '设备编号',//设备编号
  // 换电柜编辑
  'Equipment qr code': '设备二维码',
  'Delivery address': '投放地址',//投放地址
  'Please select the delivery address': '请选择收货地址',
  'Detailed address': '详细地址',
  'Please enter the detailed address': '请输入详细地址',
  'Replaceable Battery spec': '可换电池规格',//可换电池规格
  'Replaceable battery material': '可换电池材料',//可换电池材料
  'Battery collection conditions': '领取电池条件',//领取电池条件
  'The actual replaceable battery in the cabinet is not less than': '柜内实际可换电池不少于',//柜内实际可换电池不少于
  'Return of battery conditions': '退还电池条件',//退还电池条件
  'There should be no less space in the cabinet': '柜内可用空格口不少于',  //柜内可用空格口不少于
  'Business hours': '营业时间',//营业时间
  'Real picture': '实景图',//实景图
  'Number of replaceable batteries': '可换电池数量',//可换电池数量
  'Equipment version': '设备版本',
  'Protocol version': '协议版本',//协议版本
  'Equipment status': '设备状态',
  'Please upload pictures below 2m': '请上传2m以下的图片',
  'Please enter the equipment name': '请输入设备名称',//请输入设备名称
  'Please enter the delivery address': '请输入投放地址',//请输入投放地址
  'Please select a replaceable battery specification': '请选择可换电池规格',//请选择可换电池规格
  'Please select the equipment version': '请选择设备版本',//请选择设备版本
  'Please select the protocol version': '请选择协议版本',//请选择协议版本
  'The number of exchangeable batteries is illegal': '可换电池数量参数非法！',//可换电池数量参数非法！
  'Make sure to deactivate the equipment': '确定停用该设备',//确定停用该设备
  'Determine the device': '确定启用该设备 ?',//确定启用该设备
  'unselected': '未选择',//未选择
  'bound': '绑定',//绑定
  'unbound': '未绑定',
  'Replace QR code': '替换二维码',
  'Binding QR code': '绑定二维码',
  'View QR code': '查看二维码',
  // 换电柜详情
  'version': '版本',
  'Power status of equipment': '设备通电状态：',//设备通电状态：
  'Equipment service status': '设备服务状态',//
  'Used electricity': '已使用电量',//已使用电量
  'View equipment snapshot': '查看设备快照',//查看设备快照
  'View the sending request record': '查看发送请求记录',//查看发送请求记录
  'sending request record': '发送请求记录',//发送请求记录
  'View the ops operation record': '查看运维操作记录',//查看运维操作记录
  'electricity': '通电',//通电
  'Power cut': '断电',//断电
  'Port number': '端口编号',//端口编号
  'Port state': '端口状态',//端口状态
  'Port current/voltage': '端口电流/电压',//端口电流/电压
  'voltage': '电压',
  'current': '电流',
  'voltage difference': '压差',
  'Port service status': '端口服务状态',//端口服务状态
  'Port charged amount/Charging time': '端口已充电量/充电时长',//端口已充电量/充电时长
  'Charged amount': '已充电量',//已充电量
  'Battery current/voltage/Voltage difference': '电池电流/电压/压差', //电池电流/电压/压差
  'Battery Power/Health level': '电池电量/健康程度',//电池电量/健康程度
  'Health level': '健康状态',//健康状态
  'Battery specification':'电池健康',
  'Last update time':'最后更新时间',
  'Port battery SN': '端口电池通讯板编号',
  'The highest battery temperature/lowest': '电池温度最高/最低',//电池温度最高/最低
  'Max battery temperature': '电池最高温度',//最高温度
  'Min battery temperature': '电池最低温度',//最低温度
  'temperature':'温度',
  'minutes': '分钟',
  'Battery version':'电池版本',
  'MOS Temperature charging/discharge': 'MOS温度充电/放电',//MOS温度充电/放电
  'Charging temperature': '充电温度',//充电温度
  'Discharge temperature': '放电温度',// 放电温度
  'Battery cycle number': '电池循环次数',//电池循环次数
  'State of cabinet door': '柜门状态',//柜门状态
  'Refresh time': '刷新时间',//刷新时间
  'Monomer voltage': '单体电压',//单体电压
  'To view': '查看',//查看
  'refresh': 'refresh',
  'Please specify the reason for disabling the port:': '请输入停用原因',//请输入停用原因
  'View cell voltage': '查看单体电压',//查看单体电压
  'time': '时间',
  'Cell voltage number': '单体电压编号',//单体电压编号
  'Receiving time': '接收时间',//接收时间
  'energized': '已通电',//已通电
  'Power out': '电源输出',//Power out
  'Wrong QR code': '错误的二维码',//Wrong QR code
  'Make sure to deactivate the port': '确定停用该端口',//确定停用该端口
  'Whether to confirm the power cut': '是否确定断电',//是否确定断电
  'Whether determine the sync upload the qr code': '是否确定同步上传二维码',//是否确定同步上传二维码
  'No': 'No',//号
  'Whether to determine the power': '是否确定断电',//是否确定断电\
  'Whether to confirm the power': '是否确定通电',//是否确定通电
  'is sure open cupboard door': '号柜门是否确定打开',//号柜门是否确定打开
  'Charging pile management': '充电桩管理',//充电桩管理
  'Equipment snapshot': '设备快照',//设备快照
  'Charging charge station management': '充电柜管理',//充电柜管理
  'Change charge station management': '换电柜管理',//换电柜管理
  'Equipment snapshot number': '设备快照编号',//设备快照编号
  'Port current': '端口电流',//端口电流
  'Port voltage': '端口电压',//端口电压
  'battery SN': '电池通讯板号',//电池通讯板号
  'Battery Power': '电池电量',//电池电量
  'Battery current': '电池电流',//电池电流
  'no data': '暂无数据',//暂无数据
  'The': '第',//第
  'page': '页',//页
  'total': '共',
  'The current page': '当前页',//当前页
  'item': '条',//条
  'Jump to': '跳转到',//跳转到
  'Previous page': '上一页',//上一页
  'Next page': '下一页',//下一页
  'Not shown': '未展示',//未展示
  'type': '类型',//类型
  // 发送请求记录
  'Request number': '请求编号',//请求编号
  'Send time': '发送时间',//发送时间
  'content': '内容',//内容
  'operator': '操作人',//操作人
  'status': '状态',//
  'all': '全部',//全部
  'user': '用户',
  'Old Charging Service': '旧充电服务',//旧充电服务
  'New Charging Services': '新充电服务',//新充电服务
  'Charging cabinet charging service': '充电柜充电服务',//充电柜充电服务
  'Charging cabinet service door reminder': '充电柜服务开门提醒',//充电柜服务开门提醒
  'Charging cabinet service user additional operation': '充电柜服务用户额外操作',//充电柜服务用户额外操作
  'Remote upgrade of cabinet': '柜子远程升级',//柜子远程升级
  'Get the battery': '领取电池',//领取电池
  'Receive batteries for additional operations': '领取电池额外操作',//领取电池额外操作
  'Return battery': '退还电池',//退还电池
  'Return the battery for additional operation': '退还电池额外操作',//退还电池额外操作
  // 运维操作记录
  'Operation and maintenance records': '运维操作记录',//运维操作记录
  'Operation reason': '操作原因',//操作原因
  'Open the door': '开门',//开门
  'Close the door': '关门',//关门
  'In the battery': '放入电池',//放入电池
  'Take out the battery': '取出电池',//取出电池
  //
  // 开卡,卡管理
  'Card number': '卡号',//卡号
  'Choose battery': '选择电池',
  'Product number': '商品编号',//商品编号
  'Product name': '商品名称',
  'Commodity price': '商品单价',//商品单价
  'Deposit': '押金',
  'Effective time': '有效时长',//有效时长
  'Product types': '商品类型',//商品类型
  'Payment details': '付款详情',
  'Enter or read the card number': '输入或读取卡号',
  'Please select an organization': '请选择组织',
  'Enter Card password': '输入卡密',
  'Choose a package': '选择套餐',//选择套餐
  'Number of replacement cards': '换卡数量',
  'Card opening details': '开卡详情',
  'Battery Number': '电池编号',
  'Set meal': '套餐',
  'Effective Total Time': '有效总时间',
  'Amount': '金额',//金额
  'Total Rent': '总租金',
  'Time': '时间',
  'Card status': '卡状态',
  'The remaining number of days': '剩余天数',//剩余天数
  'Current effective time': '当前有效时间',
  'Username': '用户名',
  'Please input name': '请输入姓名',
  'User contact': '用户联系方式',//用户联系方式
  'Activation time': '操作时间',
  'Operating': '操作',//操作
  'Reset card password': '重置卡密',
  'Open card': '开卡',
  'Please select battery spec': '请选择电池规格',
  ' Please select card status': ' 请选择卡状态',
  'Edit user': '编辑用户',
  'Prompt': '提示',//提示
  'Please enter the reset card password': '请输入重置卡密码',
  'Please enter the reset card password again': '请再次输入重置卡密码',
  'Password at least 6 characters': '密码至少6位',
  //开卡message
  'The password cannot be empty': '密码不能为空',
  'account cannot be empty': '账号不能为空',//账号不能为空
  'Please select package and battery': '请选择套餐和电池', //请选择套餐和电池
  'Please select agent': '请选择所属代理商',//请选择所属代理商
  // 卡管理详情
  'User Info': '用户信息',//用户信息
  'Organization': '所属组织',//所属组织
  'Document No': '证件编号',
  'Product specifications': '商品规格',//商品规格
  'valid date': '有效日期',
  'Report loss/recovery': '上报 损失/恢复',
  'Attribution': '归属',
  'Status': '状态',
  'Switch state': '开关状态',
  'Whether to confirm that the switching status is': '是否确认切换状态为',//是否确认切换状态为
  'Loss reporting': '损失报告',
  'restore': '恢复',
  'Whether to confirm': '是否确认',//是否确认
  'Current battery spec': '当前电池规格',
  // 续费
  'Credential status': '凭证状态',
  'Number of replace ment cards': '更换卡数量',
  'Renewal Details': '续费详情',//续费详情
  // 用户管理
  'Account number': '帐号',
  'Please enter your account number': '请输入账号',
  'Permission': '权限方案',
  'Please select a permission': '请选择权限方案',
  'Please enter the binding card number': '请输入绑定卡号',
  'Assign users': '分配用户',
  'Add': '新增',
  'Store': '门店',
  'Setup time': '创建时间',//创建时间
  'Move out': '移出',
  'Modify permissions': '修改权限',
  'Account': '账户',
  'Password': '密码',
  'Please enter the password': '请输入密码',
  'Confirm password': '确认密码',
  'Please enter the password again': '请再次输入密码',
  'Please select an assignment object': '请选择赋值对象',
  'Change user name': '更换用户名',
  'Are you sure to move the user out of the agency or store': '您确定要将用户移出代理商或门店吗',
  'Add account': '添加账号',
  'Edit permissions': '编辑权限',
  'No permission': '无权限',
  'All permissions': '所有权限',
  'Please enter user name': '请输入用户名',
  'Please select equipment': '请选择设备',
  // 代理商管理
  'Please input Agent/Store': '请输入代理商',//请输入代理商
  'Organization number': '组织编号',//组织编号
  'Please enter the organization number': '请输入组织编号',//请输入组织编号
  'Associated account': '关联账号',//关联账号：
  'Please enter the associated account': '请输入关联账号',//请输入关联账号
  'Character': '角色:',//角色
  'please choose Character': '请选择角色',//请选择角色
  'Add agent': '新增代理商',//新增代理商
  'Agent/Store name': '代理商/门店名称',//名称
  'Area': '地区',//地区
  'Affiliated agent': '所属代理商',//所属代理商
  'Delete': '删除',//删除
  'New store': '新建门店',//新建门店
  'Agent name': '门店名称',//门店名称
  'Agent area': '代理商地区',//代理商地区
  'Agent address': '代理商地址',//代理商地址
  'Store name': '门店地址',//门店地址
  'Please enter the store name': '请输入门店名称',//
  'Store area': '门店地区',//门店地区
  'Store address': '门店地区',//门店地区
  'Please enter the store address': '请输入门店地址',//请输入门店地址
  'Please enter the agent name': '请输入代理商名称',//请输入代理商名称
  'please choose Agent area': '请输入代理商地区',//请输入代理商地区
  'Please enter the agent address': '请输入代理商地址',//请输入代理商地址
  'Whether confirm to delete this agent/stores': '是否确认删除此代理商',//是否确认删除此代理商/门店
  'The agent name cannot be empty': '代理商名称不能为空',//代理商名称不能为空
  'Associated account cannot be empty': '关联账号不能为空',//关联账号不能为空
  'Edit store': '编辑门店',//编辑门店
  'Edit agent': '编辑代理商',//编辑代理商
  'agent': '代理商',//代理商呢
  'store': '门店',//门店
  // 换电订单
  'Order Details': '订单详情',//订单详情
  'Completion progress': '完成进度',//完成进度
  'Order status': '订单状态',//订单状态
  'Please select order status': '请选择订单状态',//请选择订单状态
  'To be paid': '代付款',//代付款
  'Payment has been': '已付款',//已付款
  'finished': '已完成',//已完成
  'closed': '已关闭',//已关闭
  'Order time': '下单时间',//下单时间
  'Device address': '设备地址',//设备地址
  'Switch cabinet number': '换电柜编号',//换电柜编号
  'Name of switch cabinet': '换电柜名称',//换电柜名称
  'Name of': '换电柜',
  'switch cabinet': '名称',
  'Swap in and swap': '换入换出',
  'out Battery SN': '电池通讯板号',
  'Swap in and swap out Battery SN': '换入换出电池通讯板号',//换入换出电池通讯板号
  'Switch in and switch': '换入换出',
  'out of the cabinet door': '柜门',
  'Switch in and switch out of the cabinet door': '换入换出柜门',//换入换出柜门
  'Swap in and': '换入换出',
  'out of power': '电量',
  'Swap in and out of power': '换入换出电量',//换入换出电量
  'Swap in and swap out health status': '换入换出健康状态',//换入换出健康状态
  'lump sum': '总额',//总额
  'View order details': '查看订单详情',//查看订单详情
  'phone': '手机号',
  'Total amount payable': '应付总额',//应付总额
  'Actual amount': '实付总额',//实付总额
  'Commodity information': '商品信息',//商品信息
  'product name': '商品名称',//商品名称
  'Suborder status': '子订单状态',//子订单状态
  'consignor': '发货人',//发货人
  'Delivery time': '发货时间',//发货时间
  'Order information': '订单信息',//订单信息
  'Time of payment': '付款时间',//付款时间
  'Terms of payment': '付款方式',//付款方式
  'Completion time': '完成时间',//完成时间
  'Single amount payable': '单次应付金额',//单次应付金额
  'Total number of stages': '分期总数',//分期总数
  'Stage interval': '分期间隔时间',//分期间隔时间
  'Staging Details': '分期详情',//分期详情
  'Staging number': '分期序号',//分期序号
  'Last payment date': '最后付款日',//最后付款日
  'Actual payment time': '实际付款时间',//实际付款时间
  'Payment method': '付款方式',//付款方式
  'The fashionable details': '分账详情',//分账详情
  'Close ledger': '关闭分账',//关闭分账
  'Please enter the reason for closing the ledger': '请输入关闭分账原因',//请输入关闭分账原因
  'Cause of failure': '失败原因',//失败原因
  'Please enter the reason for closing': '请输入关闭原因',//请输入关闭原因
  'Please enter 1-30 characters': '请输入1-30个字符',//请输入1-30个字符
  'Distributing record number': '分账记录编号',//分账记录编号
  'Description of itemized goods': '分账商品描述',//分账商品描述
  'Name of ledger organization': '分账组织名称',//分账组织名称
  'Type of ledger account': '分账账户类型',//分账账户类型
  'Record setup time': '记录创建时间',//记录创建时间
  'Enterprise Alipay account': '企业支付宝账户',//企业支付宝账户
  'Second-level inbound merchants': '二级进件商户',//二级进件商户
  'Alipay login account': '支付宝登录账户',//支付宝登录账户
  'Undivided account': '待分账',//待分账
  'In ledger': '分账中',//分账中
  'Distributed account': '已分账',//已分账
  'Collecting a failure': '分账失败',//分账失败
  'To be settled': '待结算',//待结算
  'In settlement': '结算中',//结算中
  'settled': '已结算',//已结算
  'Settlement failures': '结算失败',//结算失败
  'Close allotment failed': '关闭分账失败',//关闭分账失败
  'phase': '期',//期
  'Service type': '服务类型',//服务类型
  'In electricity': '换电费',//换电费
  'preferential': '优惠',//优惠
  'Power Changing Service': '换电服务',//换电服务
  'Swap out': '换出',//换出
  'Swap in': '换入',//换入
  'Amount of goods': '商品数量',//商品数量
  'Amounts payable': '应付金额',//应付金额
  'The amount actually paid': '实付金额',//实付金额
  'Total cost': '总费用',//总费用
  // 开卡订单详情
  'Card opening order details': '开卡订单详情',//
  'Battery unit price': '电池单价',//电池单价
  'Exit failure': '退出失败',//退出失败
  '三元锂': '三元锂',//三元锂
  '磷酸铁锂': '磷酸铁锂',//磷酸铁锂
  'In the electricity service': '换电服务',//换电服务
  'Operational records': '运维记录',//运维记录
  'In electrical service user additional operations': '换电服务用户额外操作',//换电服务用户额外操作
  'System request': '系统请求',//系统请求
  'Offline in electricity': '离线换电',//离线换电
  'The query results information offline in electricity': '查询离线换电结果信息',//查询离线换电结果信息
  'Relay on': '继电器开启',//继电器开启
  'Relay off': '继电器关闭',//继电器关闭
  'failure': '失败',//失败
  'Success': '成功',//成功
  'In process': '处理中',//处理中
  'battery': '电池',//电池
  'health': '健康',
  'Check progress': '查看进度',//查看进度
  'name': '姓名',
  'In the electric cabinet': '换电柜',//换电柜
  'Charging port': '充电口',//充电口
  'disconnected': '已断开连接',//已断开连接
  'The battery is not plugged in': '没有插上电池',//没有插上电池
  'Battery charging': '电池充电中',//电池充电中
  'Battery charging switch':'电池充电开关',
  'The battery is fully charged': '电池已充满',//电池已充满
  'Has been on the battery': '已经插上电池',//已经插上电池
  'Charging on': '充电开启中',//充电开启中
  'Battery failure': '电池故障',//电池故障
  'Unable to read port state': '无法读取端口状态',//无法读取端口状态
  'open': '开启',//开启
  'Shut down': '关闭',//关闭
  'Offline payment': '线下支付',//线下支付
  'Remaining Completion Time': '剩余完成时间',//剩余完成时间
  'sec': '秒',//秒
  'Cabinet door': '柜门',//柜门
  'opened': '已打开',//已打开
  'opening': '正在打开',//正在打开
  'At buzzer':'蜂鸣中',
  'Not buzzer':'未蜂鸣',
  'Lock':'锁定',
  'Not Lock':'未锁定',
  'Look State':'查看切换状态',
  'Switching state':'切换状态',
  'Put in the battery and close the cabinet door': '请放入电池并关闭柜门',//请放入电池并关闭柜门
  'Make sure the battery is plugged in': '请务必确认插好电池',//请务必确认插好电池
  'Please remove the battery and close the cabinet door': '请取出电池并关闭柜门',//请取出电池并关闭柜门
  'Successful, confirm return': '已成功，确认返回',//已成功，确认返回
  'Failed, confirm return': '已失败，确认返回',//已失败，确认返回
  'In the electric card': '换电卡',//换电卡
  'Battery holding certificate': '电池持有凭证',//电池持有凭证
  'login number': '登录账号',
  'User Number': '用户账号',
  //开卡
  'Battery spec': '电池规格',

  //开卡订单
  'Order number': '订单编号',
  'Order number input': '请输入订单编号',
  'Total payment amount': '支付总额',
  'Order Number': '订单编号',
  // 换电柜管理
  'Charge station management': '换电柜管理',
  'Device ID': '设备编号',
  'Please-enter-the-device-number': '请输入设备编号/通讯板编号',
  'Please-enter-the-device-name': '请输入设备名称',
  'Agent/Store': '所属代理商/门店',
  'Service status': '服务状态',
  //
  'Communication board number': '通讯板编号',
  'Equipment type': '设备类型',
  'Equipment name': '设备名称',
  'Location address': '定位地址',
  'Agent': '所属代理商',
  'Device power state': '设备通电状态',
  'Battery used': '已使用电量',
  'Device Status': '设备状态',
  //
  'Number of batteries': '已有电池数量',
  'Number of unplugged batteries': '未插电池数量',
  'selected location': '已选地址',


  // 公共
  'Please choose': '请选择',
  'Details': '详情',
  'Look Details': '查看详情',
  'Edit': '编辑',
  'new': '新增',
  'Inquire': '查询',
  'Distribution': '分配',
  'View Details': '查看详情',
  'Import': '导入',
  'Import File': '导入文件',
  // 新增公共
  'day': '天',
  'Quantity': '数量',//数量
  'Rent': '租金',
  'Total amount': '总额',//总额
  'Card password': '卡密',
  'Name': '姓名',//姓名
  'Contact details': '详细联系方式',
  'Cancel': '取消',
  'Confirm': '确定',
  'Battery': '电池',
  'Successful': '操作成功',
  'start time': '开始时间',
  'end time': '结束时间',
  'Renew': '续费',
  'The two passwords do not match': '两次密码不一致',
  'Successfully reset!': '重置成功!',
  'Edit success': '编辑成功',
  'Confirm deletion?': '确定删除?',
  'Logon has timed out. Please login again': '登录超时。请重新登录',
  'back': '返回',
  'Query failed': '查询失败',//查询失败
  'Log out': '退出登录',//退出登录
  // 下拉
  'available': '可用',
  'unavailable': '不可用',
  'Enable': '启用',
  'unenable': '停用',
  'Change the password': '修改密码',
  'prompt': '提示',
  'Modify Password': '修改密码',
  'The password can only Numbers or letters': '密码必须是数字或英文',
  'times': '次',
  'Measured card': '换电次卡 ',
  'Timer card': '换电时卡',
  'Available times': '可用次数',
  'days': '天',
  'Package': '套餐',
  'Userinfo': '用户信息',
  'Export': '导出',
  'Whether to confirm export': '是否确认导出',
  'Being exported': '正在导出',
  'Export successful': '导出成功',
  'Task type': '任务类型',
  'File name': '文件名',
  'Task Status': '任务状态',
  'Download link': '下载链接',
  'Wait to leave factory':"待出厂",
  'Device snapshot data export': '设备快照数据导出',
  'Export of order data for power exchange': '换电订单数据导出',
  'Export of SMS data statistics': '短信数据统计数据导出',
  'Sending SMS log data export': '发送短信记录数据导出',
  'User rights scheme export': '用户权限方案导出',
  'User battery data export': '用户电池数据导出',
  'Battery mileage data export': '电池里程数据导出',
  'Export of equipment exception records': '设备异常记录导出',
  'Abnormal export of the charging status of the charging port': '充电口充电状态异常导出',
  'Battery idle state export': '电池闲置状态导出',
  'Application for exchange order export': '申请换电订单导出',
  'Instalment order export': '分期订单导出',
  'Charging order export for charging cabinets': '充电柜充电订单导出',
  'Battery snapshot data export': '电池快照数据导出',
  'Electric vehicle information export': '电动车信息导出',
  'Voucher information export': '凭证信息导出',
  'Export of electricity exchange card orders': '换电卡订单导出',
  'User information export': '用户信息导出',
  'Return order export': '退还订单导出',
  'Master device information export': '主设备信息导出',
  'Battery flow record export': '电池流转记录导出',
  'User invitation record export': '用户邀请记录导出',
  'Pending': '待处理',
  'New card order export': '开卡订单导出',
  'Renewal order export': '续费订单导出',
  'Swapping station management export': '换电柜信息导出',
  'Swapping order export': '换电订单导出',
  'Download': '下载',
  'Exporting Task': '导出任务',
  'In the electric timer card': '换电时卡',
  'In the electric measured card': '换电次卡',
  'undefined': '',
  'Frequentness': '频率',
  'Statistics': '统计',
  'Electricity Statistics': '统计',
  'Vehicle Spec': '规格',
  'Online State': '在线状态',
  'ECU Manufacturer': '厂商',
  'License Plates': '车牌',
  'Operation Management': '运营管理',
  'Commodity Management': '商品管理',
  'Commodity State': '商品状态',
  'Stocks': '库存',
  'Unlimited': '无限制',
  'Price': '价格',
  'On Sale': '在售',
  'Off Sale': '停售',
  'Swapping Service': '换电服务',
  'Timer Card': '换电卡',
  'Measured Card': '换电次卡',
  'Please enter the correct amount': '请输入正确的金额',
  'Please enter the correct number of days': '请输入正确的天数',
  'Tips': '提示',
  'Error': '错误',
  'Error Code':'错误码',
  'E-Motorcycle': '电动车',
  'Operation Record': '操作记录',
  'Command Number': '操作记录编号',
  'Please enter command number': '请输入操作记录编号',
  'Operating Account': '操作账号',
  'Please enter operating account': '请输入操作记录编号',
  'Reason For Delivery': '下发原因',
  'State': '状态',
  'Normal':'正常',
  'error message':'错误信息',
  'Operation Type': '操作类型',
  'Creation time': '创建时间',
  'Execution Time': '执行时间',
  'Update Time': '更新时间',
  'Equipment Information': '设备信息',
  'Equipment Type': '设备类型',
  'ECU Number': '中控编号',
  'Vehicle Frame Number': '车架编号',
  'Linked Account': '关联账户',
  'User Mileage': '用户里程',
  'Total Mileage': '总里程',
  'ECU Information': '中控信息',
  'Hardware Version': '硬件版本号',
  'Software Version': '软件版本号',
  'Hardware type':'硬件种类',
  'ECU Battery Voltage': '中控电池电压',
  'Current Power': '当前功率',
  'Current Speed': '当前车速',
  'Started': '启动',
  'Locked': '锁定',
  'Restart ECU': '重启中控',
  'Switch': '切换',
  'Wheel Lock state': '轮锁状态',
  'Speed Limit Gear': '限速档位',
  'Backseat': '座桶锁',
  'Open': '开启',
  'ECU Fault Code': '中控故障码',
  'No data': '暂无数据',
  'View': '查看',
  'Battery Information': '电池信息',
  'Battery Type': '电池类型',
  'Battery Status': '电池状态',
  'Please select battery status':'请选择电池状态',
  'Battery Hardware Version': '电池硬件版本',
  'Battery Software Version': '电池软件版本',
  'Voltage Class': '电压等级',
  'Battery SOC': '电池SOC',
  'Battery Health': '电池健康状态',
  'Battery Temperature': '电池温度',
  'Battery Voltage': '电池电压',
  'Battery Current': '电池电流',
  'Battery Differential':'电池压差',
  'Charge state': '充电状态',
  'Discharge state': '放电状态',
  'MOS Temperature': 'MOS温度',
  'Charge MOS state': '充电MOS状态',
  'Discharge MOS state': '放电MOS状态',
  'Battery MOS status':'电池MOS状态',
  'Battery Fault Code': '电池故障码',
  'Confirm operation': '是否确认操作',
  'Vehicle Track': '设备轨迹',
  'Please enter ECU number': '请输入操作记录编号',
  'Speed Limit Gear setting': '档位参数设置',
  'Wheel locked': '轮锁上锁',
  'Wheel unlocked': '轮锁解锁',
  'Backseat locked': '座桶解锁',
  'Charge locked': '充电锁定',
  'Charge unlocked': '充电解锁',
  'Discharge locked': '放电锁定',
  'Discharge unlocked': '放电解锁',
  'All': '全部',
  'User operation': '用户操作',
  'Admin operation': '运维操作',
  'System operation': '系统操作',
  'Failure': '失败',
  'Processing': '处理中',
  'In operation': '操作中',
  'Electric vehicle trajectory': '电动车轨迹',
  'Loading': 'Loading',
  'One day at most': '最多一天',
  'Exchange status': '兑换状态',
  'Change status1': '禁用端口',
  'Change status0': '启用端口',
}
//   {{$t('lang.Register_title')}}
// $t('lang.Register_title')



// WEBPACK FOOTER //
// ./src/i18n/language-zh.js